import { DetailPageFooterRoot } from "./DetailPageFooterRoot/DetailPageFooterRoot";
import { DetailPageFooterDivider } from "./DetailPageFooterDivider/DetailPageFooterDivider";
import { DetailPageFooterActions } from "./DetailPageFooterActions/DetailPageFooterActions";

export const Root = DetailPageFooterRoot;
export const Divider = DetailPageFooterDivider;
export const Actions = DetailPageFooterActions;
